
<template>
  <section class="pw-why">
    <div class="container">
      <div class="pw-heading">
        <h2>Pourquoi choisir <span>ProduPneu</span> ?</h2>
        <p>
          Une expérience pensée pour simplifier votre
          recherche de pneus.
        </p>
      </div>

      <div class="pw-grid">
        <article
          v-for="item in reasons"
          :key="item.id"
          class="pw-card"
        >
          <div class="pw-icon">
            <svg
              v-if="item.id === 'price'"
              viewBox="0 0 24 24" fill="none"
            >
              <path d="M8 4h8v5a4 4 0 0 1-8 0V4z"/>
              <path d="M8 6H4v2a4 4 0 0 0 4 4m8-6h4v2a4 4 0 0 1-4 4M12 13v5m-4 3h8M9 18h6"/>
            </svg>

            <svg
              v-else-if="item.id === 'choice'"
              viewBox="0 0 24 24" fill="none"
            >
              <path d="m12 3 9 5-9 5-9-5 9-5z"/>
              <path d="m3 12 9 5 9-5M3 16l9 5 9-5"/>
            </svg>

            <svg
              v-else-if="item.id === 'security'"
              viewBox="0 0 24 24" fill="none"
            >
              <path d="M12 2 4 6v6c0 5 3 8 8 10 5-2 8-5 8-10V6z"/>
              <path d="m8 12 3 3 5-6"/>
            </svg>

            <svg v-else viewBox="0 0 24 24" fill="none">
              <path d="M2 7h12v10H2zM14 10h4l4 4v3h-8z"/>
              <circle cx="6" cy="18" r="2"/>
              <circle cx="18" cy="18" r="2"/>
            </svg>
          </div>

          <div class="pw-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "WhyUs",

  data() {
    return {
      reasons: [
        {
          id: "price",
          title: "Comparez les prix",
          description:
            "Explorez les différentes gammes selon votre budget.",
        },
        {
          id: "choice",
          title: "Un large choix",
          description:
            "Comparez les marques, dimensions et saisons.",
        },
        {
          id: "security",
          title: "Un parcours sécurisé",
          description:
            "Retrouvez les informations utiles avant votre achat.",
        },
        {
          id: "delivery",
          title: "Livraison adaptée",
          description:
            "Découvrez les options de livraison disponibles.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.pw-why {
  padding: 55px 0 65px;
  background: #fff;
  font-family: "Poppins", sans-serif;
}

.pw-heading {
  margin-bottom: 22px;
}

.pw-heading h2 {
  color: #1c2228;
  font-size: clamp(25px, 2.6vw, 34px);
  font-weight: 900;
  letter-spacing: -.7px;
  margin: 0 0 7px;
}

.pw-heading h2 span {
  color: #ff7900;
}

.pw-heading p {
  color: #7e8790;
  font-size: 12px;
  margin: 0;
}

.pw-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 15px;
}

.pw-card {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 20px 17px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 11px;
  box-shadow: 0 3px 15px rgba(18,25,31,.04);
  transition: transform .25s, box-shadow .25s;
}

.pw-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 13px 32px rgba(18,25,31,.09);
}

.pw-icon {
  flex-shrink: 0;
  color: #ff7900;
}

.pw-icon svg {
  width: 36px;
  height: 36px;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.pw-content h3 {
  color: #20262c;
  font-weight: 800;
  font-size: 12px;
  line-height: 1.45;
  margin: 1px 0 6px;
}

.pw-content p {
  color: #818992;
  font-size: 10px;
  line-height: 1.7;
  margin: 0;
}

@media (max-width: 991px) {
  .pw-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575px) {
  .pw-why {
    padding: 45px 0 50px;
  }

  .pw-grid {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pw-card {
    transition: none;
  }
}
</style>
